import { Settings } from '@config/game.js'
import {
  USER_COLLECTION_BROWSE_ROUTE,
  MOD_BROWSE_ROUTE_TOKEN_PACKS,
  MOD_ADMIN_SETTINGS_ROUTE,
  USER_GUIDE_BROWSE_ROUTE,
  COLLECTION_BROWSE_ROUTE,
  COLLECTION_VIEW_ROUTE,
  USER_MOD_BROWSE_ROUTE,
  GAME_FEATURED_ROUTE,
  LOCALISATION_ROUTE,
  GUIDE_BROWSE_ROUTE,
  GUIDE_VIEW_ROUTE,
  MOD_BROWSE_ROUTE,
  FOUROHFOUR_ROUTE,
  MOD_VIEW_ROUTE,
  MOD_ADD_ROUTE,
  LIBRARY_ROUTE,
  CONTENT_ROUTE,
  USER_ROUTE,
} from '@config/routeNames.js'

const routes = [
  {
    path: '/',
    name: MOD_BROWSE_ROUTE,
    component: () => import('@views/ModBrowse.vue'),
    meta: { browse: true },
  },
  {
    path: '/u/:user',
    name: USER_ROUTE,
    component: () => import('@views/UserView.vue'),
    children: [
      {
        name: USER_MOD_BROWSE_ROUTE,
        path: '',
        component: () => import('@views/ModBrowse.vue'),
      },
    ],
  },
  {
    path: '/m/:mod',
    name: MOD_VIEW_ROUTE,
    component: () => import('@views/ModView.vue'),
    meta: { content: true },
  },
  {
    path: '/m/add',
    name: MOD_ADD_ROUTE,
    component: () => import('@views/ModAdd.vue'),
  },
  {
    path: '/m/:mod/admin',
    redirect: { name: MOD_ADMIN_SETTINGS_ROUTE },
    component: () => import('@views/ModAdmin.vue'),
    children: [
      {
        path: 'settings',
        name: MOD_ADMIN_SETTINGS_ROUTE,
        component: () => import('@components/ModAdmin/ModSettings.vue'),
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: '/library',
    name: LIBRARY_ROUTE,
    meta: { requiresAuth: true },
    component: () => import('@views/Library.vue'),
  },
  {
    path: '/content',
    name: CONTENT_ROUTE,
    meta: { requiresAuth: true },
    component: () => import('@views/Content.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: FOUROHFOUR_ROUTE,
    component: () => import('@views/404.vue'),
  },
]

if (Settings.value.showFeatured) {
  routes.push({
    path: '/',
    name: GAME_FEATURED_ROUTE,
    component: () => import('@views/Featured.vue'),
    meta: { browse: true },
  })

  routes.find((r) => r.name === MOD_BROWSE_ROUTE).path = '/m'
}

if (Settings.value.showMarketplace) {
  routes.push({
    path: '/currency-packs',
    name: MOD_BROWSE_ROUTE_TOKEN_PACKS,
    component: () => import('@views/ModBrowse.vue'),
  })
}

if (Settings.value.showCollections) {
  routes.push({
    path: '/c',
    name: COLLECTION_BROWSE_ROUTE,
    component: () => import('@views/CollectionBrowse.vue'),
    meta: { browse: true },
  })

  routes.push({
    path: '/c/:collection',
    name: COLLECTION_VIEW_ROUTE,
    component: () => import('@views/CollectionView.vue'),
    meta: { content: true },
  })

  routes
    .find((route) => route.name === USER_ROUTE)
    .children.push({
      name: USER_COLLECTION_BROWSE_ROUTE,
      path: 'c',
      component: () => import('@views/CollectionBrowse.vue'),
    })
}

if (Settings.value.showGuides) {
  routes.push({
    path: '/r',
    name: GUIDE_BROWSE_ROUTE,
    component: () => import('@views/GuideBrowse.vue'),
    meta: { browse: true },
  })

  routes.push({
    path: '/r/:guide',
    name: GUIDE_VIEW_ROUTE,
    component: () => import('@views/GuideView.vue'),
    meta: { content: true },
  })

  routes
    .find((route) => route.name === USER_ROUTE)
    .children.push({
      name: USER_GUIDE_BROWSE_ROUTE,
      path: 'r',
      component: () => import('@views/GuideBrowse.vue'),
    })
}

if (import.meta.env.DEV) {
  routes.push({
    path: '/localisation',
    name: LOCALISATION_ROUTE,
    component: () => import('@views/Localisation.vue'),
  })
}

export default routes
